import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="autogrow"
// A textarea that is as tall as its text. The cap is CSS (max-h-*): the
// textarea only scrolls past it — below, a scrollbar would flash at each line.
// Rendered hidden (a modal not open yet), it has no height to measure: it
// resizes once it shows up.
export default class extends Controller {
  connect() {
    this.observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) this.resize()
    })
    this.observer.observe(this.element)
    this.resize()
  }

  disconnect() {
    this.observer?.disconnect()
  }

  resize() {
    const field = this.element
    if (!field.offsetParent) return

    const borders = field.offsetHeight - field.clientHeight
    field.style.height = 'auto'
    const height = field.scrollHeight + borders
    const cap = parseFloat(getComputedStyle(field).maxHeight)

    field.style.height = `${height}px`
    field.style.overflowY = height > cap ? 'auto' : 'hidden'
  }
}
